export default __webpack_public_path__ + "static/google-transform-b10245a2e5b78f28316815ea8a423cb1.svg";